module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"admin":{"homepage":{"title":"Section d\u0027administration","manage-obs-point":"Gérer les points d\u0027observations","manage-user":"Gérer les utilisateurs","import-data":"Importer des chroniques"}}},"de":{}}')
  delete Component.options._Ctor
}
